export default __webpack_public_path__ + "static/media/typey1.27bab184.jpg";